import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import home from './components/home/home.component';
import campaignsPlaceHolder from './components/campaignsPlaceHolder/campaignsPlaceHolder.component';

/**
 * @ngdoc overview
 * @name home
 * @description
 * This module handles everything for the Home section.
 */
const homeModule = angular.module('home', [])
.config(routeProviderConfig)
.component('home', home)
.component('campaignsPlaceHolder', campaignsPlaceHolder);

export default homeModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/home/index.js